/**
 * @file useHorizontalScroll - 判断是否可以水平滚动的自定义 Hook
 */

import {useRef, useState, useEffect, useCallback} from 'react';

export const useHorizontalScroll = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollState = useCallback(() => {
        const el = containerRef.current;
        if (!el) return;

        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth);
    }, []);

    useEffect(() => {
        const el = containerRef.current;
        if (!el) {
            return () => {};
        }

        updateScrollState();
        el.addEventListener('scroll', updateScrollState);

        const observer = new ResizeObserver(updateScrollState);
        observer.observe(el);

        return () => {
            el.removeEventListener('scroll', updateScrollState);
            observer.disconnect();
        };
    }, [updateScrollState]);

    const scrollLeft = useCallback(() => {
        const el = containerRef.current;
        if (!el) return;

        el.scrollBy({
            left: -290, // 每次滚动一个卡片宽度
            behavior: 'smooth',
        });
    }, []);

    const scrollRight = useCallback(() => {
        const el = containerRef.current;
        if (!el) return;

        el.scrollBy({
            left: 290,
            behavior: 'smooth',
        });
    }, []);

    return {
        containerRef,
        canScrollLeft,
        canScrollRight,
        scrollLeft,
        scrollRight,
    };
};
